import { useDispatch, useSelector } from "react-redux";
import cancel_img from '../../assets/images/cancel.svg'

import { selectTranslations } from "../../services/i18n/i18nSlice";
import { selectAppPersonalizations } from "../../services/utils/appInfoSlice";
import { confirmAccountEmail, resetVerificationTimeout, selectAppAuth, verifyAccountEmail } from "../../services/auth/authSlice";
import { useEffect, useState } from "react";
import { Navigate, redirect, useLocation, useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';

import tf_logo from '../../assets/images/logo_blue.svg'

import Text from "../../components/Text";
import TitleH1 from "../../components/TitleH1";
import Button from "../../components/Button";
import PinInput from 'react-pin-input';
import { checkUserFields, selectUserInfo } from "../../features/User/userSlice";
import Anchor from "../../components/Anchor";

import './LoginScreen.css'
import Timer from "../../components/Timer";
import AdminWaitingScreen from "./AdminWaitingScreen";
import { API_URL } from "../../config/constants";



export default function LoginScreen () {

    const personalizations = useSelector(selectAppPersonalizations)
    const userAuth = useSelector(selectAppAuth)
    const userInfo = useSelector(selectUserInfo)
    const t = useSelector(selectTranslations);
    const missingFields = useSelector(checkUserFields)
    const dispatch = useDispatch();

    const [loginEmail, setLoginEmail] = useState("")
    const [legalCheck, setLegalCheck] = useState(false)

    const resetLoginEmail = () => {
        setLoginEmail('')
    }

    const handleUpdateLoginEmail = (e) => {
        setLoginEmail(e.target.value)
    }

    const startLoginProcess = (e) => {
        if(!legalCheck){

        }
        if(loginEmail !== "")
            dispatch(verifyAccountEmail(loginEmail))
    }

    const handleVerifyPin = (value, index) => {
        dispatch(confirmAccountEmail({email: loginEmail, pin: value}))
    }
    
    const renderError = (error) => {
        switch(error){
            case 'security_pin or security_token must be provided':
                return t.login.malformed_auth;
            break;
            case 'user verification not found':
                return t.login.missing_user;
            break;
            case 'wrong security pin':
                return t.login.wrong_pin;
            break;
            case 'user has been suspended':
                return t.login.suspended_user;
            break;
        }
    }

    return(
        <div id="loginScreen">
            { !userAuth?.auth_token? 
            <>
                { !userAuth.authPending? 
                    <div className="fh-div d-flex flex-column align-items-center justify-content-between">
                        <div className="top">
                            <img src={ personalizations?.logo_url ? `${API_URL}${personalizations?.logo_url}` : tf_logo} className="mx-auto d-block" style={{maxWidth:'200px'}} />
                            <TitleH1 className="text-center mt-4">{t.login.login_email}</TitleH1>
                            <Text className="text-center mt-2">{t.login.login_text}</Text>
                            <div className="email_login_box">
                                <input className="email_login_input" type="email" onChange={handleUpdateLoginEmail} value={loginEmail} placeholder={''+t.login.email_placeholder}/>
                                <img src={cancel_img} onClick={resetLoginEmail} />
                            </div>
                            {userAuth?.error ? 
                                <Text className="text-danger">{renderError(userAuth?.error)}</Text>
                            : ""}
                        </div>
                        <div className="bottom pb-4 w-100">
                            <Form.Check type={'checkbox'} id={`internal_legal_check`} className="login_legal_check mb-3">
                                <Form.Check.Input type={'checkbox'} checked={legalCheck} onChange={()=>{setLegalCheck(!legalCheck)}}/>
                                <Form.Check.Label>
                                    {t.login.internal_legal_check_1}
                                    <a href={`/admin/static/legals/privacy-policy.pdf`} target={'_blank'}><u>{t.login.internal_legal_check_privacy}</u></a> e i&nbsp;
                                    <a href={`/admin/static/legals/termini-e-condizioni.pdf`} target={'_blank'}><u>{t.login.internal_legal_check_terms}</u></a>
                                    &nbsp;{t.login.internal_legal_check_2}
                                </Form.Check.Label>
                            </Form.Check>
                            <Button className="w-100 mx-auto" onClick={startLoginProcess} disabled={!legalCheck || loginEmail === ""}>{t.login.login_button}</Button>
                        </div>
                    </div> :
                    <div className="fh-div d-flex flex-column align-items-center justify-content-between">
                        <div className="top">
                            <img src={personalizations?.logo_url ? `${API_URL}${personalizations?.logo_url}` : tf_logo} className="mx-auto d-block" style={{maxWidth:'200px'}}/>
                            <TitleH1 className="text-center">{t.login.login_code}</TitleH1>
                            <Text className="text-center">{t.login.login_code_text} {loginEmail}</Text>
                            <PinInput 
                                length={6} 
                                initialValue=""
                                type="numeric" 
                                inputMode="number"
                                onComplete={handleVerifyPin}
                                inputStyle={userAuth?.error === "wrong security pin" ? {borderColor: 'red'} : {}}
                                autoSelect={true}
                                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                                className="mt-4"
                            />
                            { userAuth?.error ?
                                <small className="d-block w-100 mt-2 text-danger text-center">{renderError(userAuth?.error)}</small> : ""
                            }
                            <div className="mt-4">
                                <Text className="text-center mb-0">{t.login.code_missing}</Text>
                                <div className="d-flex justify-content-center align-items-center">
                                    <Anchor className="text-center d-block me-1" href="#" onClick={startLoginProcess} disabled={userAuth?.seconds_to_wait_next_verification > 0}>{t.login.send_again}</Anchor>
                                    <small>{userAuth?.seconds_to_wait_next_verification > 0 ? <>(<Timer timeout={userAuth?.seconds_to_wait_next_verification} onExpire={()=>{dispatch(resetVerificationTimeout())}} />)</> : ""}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </> : 
            <>
                {   
                    userAuth && userInfo?.user_data && userInfo?.user_data?.is_admin ?
                    <>
                        { userAuth?.admin_check_required || userInfo?.user_data?.state === "waiting_admin_check" ? 
                            <Navigate to={'/login/waiting_approval'} replace />
                        :
                            <>
                                { missingFields || !userInfo.user_data?.legal_checks?.external_legal_check ?
                                    <Navigate to={'/login/onboarding'} replace />
                                :
                                    <Navigate to={userAuth?.origin_location || '/'} replace />
                                }
                            </>
                        }
                    </> : <>
                        {
                            userInfo?.user_data && !userInfo?.user_data?.is_admin ? 
                                <Navigate to={'/no_access'} replace />
                            : ""
                        }
                    </>
                }
            </>
            }
        </div>
    )
}